import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import Intro from './Intro/Intro';
import Operators from './Operators/Operators';
import PopularDirections from './PopularDirections/PopularDirections';
import Advantages from './Advantages/Advantages';
import Description from './Description/Description';
import {
  HOME_PAGE_TITLE,
  HOME_PAGE_META_DESCRIPTION,
} from '../../Utils/Constants/SEO';
import './css/Home.css';
import Hot from './Hot/Hot';

function Home() {
  return (
    <div>
      <Helmet>
        <title>{HOME_PAGE_TITLE}</title>
        <meta name="description" content={HOME_PAGE_META_DESCRIPTION} />
        <link rel="canonical" href="https://tourhunter.by/" />
      </Helmet>
      <Intro />
      <Operators />
      <Hot />
      <PopularDirections />
      <Advantages />
      <Description />
    </div>
  );
}

export default Home;
